<template>
  <h2>
    无访问权限，请尝试退出应用后重新登录
    <!-- <van-button @click="onCopy" type="primary">复制code</van-button> -->
  </h2>
</template>

<script>

export default {
  mounted() {
  },
};
</script>
